"use client";

import { useEffect, useState, Suspense } from "react";
import dynamic from "next/dynamic";

const ConsentPopUp = dynamic(() => import("@/app/components/Consent/ConsentTermsPopup"), {
	ssr: false,
});

const CookieConcentPopup = dynamic(() => import("@/app/components/Consent/Cookie"), {
	ssr: false,
	loading: () => null,
});

const AffiliateLandingCapture = dynamic(
	() => import("@/lib/analytics/AffiliateLandingCapture"),
	{ ssr: false, loading: () => null },
);

const PresenceManager = dynamic(() => import("@/components/PresenceManager"), {
	ssr: false,
});

const WebPushRegistration = dynamic(
	() => import("@/components/notifications/WebPushRegistration"),
	{ ssr: false, loading: () => null },
);

const BasketSyncManager = dynamic(() => import("@/components/BasketSyncManager"), {
	ssr: false,
});

const GuestLauraDraftHandoffManager = dynamic(
	() => import("@/components/GuestLauraDraftHandoffManager"),
	{ ssr: false, loading: () => null },
);

const ThemeToggle = dynamic(() => import("@/components/ThemeToggleWrapper"), {
	ssr: false,
});

const CtaClickTracker = dynamic(() => import("@/components/analytics/CtaClickTracker"), {
	ssr: false,
	loading: () => null,
});

export default function ClientOnlyComponents() {
	const [mounted, setMounted] = useState(false);
	const [showCookiePopup, setShowCookiePopup] = useState(false);
	const [cookieBannerVisible, setCookieBannerVisible] = useState(false);

	useEffect(() => {
		setMounted(true);
		// Small delay to ensure all dependencies are loaded
		const timer = setTimeout(() => {
			setShowCookiePopup(true);
		}, 100);
		return () => clearTimeout(timer);
	}, []);

	return (
		<>
			<PresenceManager />
			<WebPushRegistration />
			<BasketSyncManager />
			<GuestLauraDraftHandoffManager />
			{mounted && (
				<>
					<CtaClickTracker />
					<Suspense fallback={null}>
						<AffiliateLandingCapture />
					</Suspense>
					<ConsentPopUp />
					{showCookiePopup && (
						<Suspense fallback={null}>
							<CookieConcentPopup onBannerVisibilityChange={setCookieBannerVisible} />
						</Suspense>
					)}
					{!cookieBannerVisible && <ThemeToggle />}
				</>
			)}
		</>
	);
}

